export const c1 = [
    {
        "anio" : "Marco Organizacional de Control Interno",
        "descripcion" : "Normatividad, Acuerdos ...",
        "trimestres" : [
            {
                "trimestre" : "Código de Conducta",
                "url" : "/pdf/CodigoDeConducta.pdf"
            },
            {
                "trimestre" : "Código de Ética",
                "url" : "/pdf/codigoEtica.pdf"
            },
            {
                "trimestre" : "Marco Integrado de Control Interno ",
                "url" : "/pdf/MEMICI.pdf"
            },
            {
                "trimestre" : "Modelo Estatal de Marco Integrado de Control Interno para el Sector Público del Estado de Hidalgo.",
                "url" : "/pdf/marcoIntegrado.pdf"
            },
            {
                "trimestre" : "Sistema de Control Interno Institucional de la SECTURH",
                "url" : "/pdf/siictur.pdf"
            },,
            {
                "trimestre" : "Plan de sucesión y contingencia de las suplencias por ausencia de las personas servidoras públicas",
                "url" : "/pdf/planContingencia.pdf"
            },,
           
        ]
    },{
        "anio" : "Comité de Control y Desempeño Institucional",
        "descripcion" : "Actas de las sesiones COCODI",
        "trimestres" : [
            {
                "trimestre" : "Primera Sesión 2024",
                "url" : "/pdf/1Acocodi.pdf"
            },
            {
                "trimestre" : "Segunda Sesión 2024",
                "url" : "/pdf/2Acocodi.pdf"
            },
            {
                "trimestre" : "Tercera Sesión 2024",
                "url" : "/pdf/3Acocodi.pdf"
            },
            {
                "trimestre" : "Cuarta Sesión 2024",
                "url" : "/pdf/4Acocodi.pdf"
            },
            {
                "trimestre" : "Primera Sesión 2025",
                "url" : "/pdf/1A25cocodi.pdf"
            },
            {
                "trimestre" : "Segunda Sesión 2025",
                "url" : "/pdf/2A25cocodi.pdf"
            },
            {
                "trimestre" : "Tercera Sesión 2025",
                "url" : "/pdf/3A25cocodi.pdf"
            },
            {
                "trimestre" : "Cuarta Sesión 2025",
                "url" : "/pdf/4A25cocodi.pdf"
            },
            {
                "trimestre" : "Primera Sesión 2026",
                "url" : "/pdf/1A26cocodi.pdf"
            },
            {
                "trimestre" : "Segunda Sesión 2026",
                "url" : "/pdf/2A26cocodi.pdf"
            },
            
        ]
    },{
        "anio" : "Programa de Capacitación",
        "descripcion" : "Documentos CEPCI",
        "trimestres" : [
            {
                "trimestre" : "Programa Anual 2024",
                "url" : "/pdf/p2024cepci.pdf"
            },
            {
                "trimestre" : "Primera sesión 2024",
                "url" : "/pdf/sesion1Cepci.pdf"
            },
            {
                "trimestre" : "Segunda sesión 2024",
                "url" : "/pdf/sesion2Cepci.pdf"
            },
            {
                "trimestre" : "Tercera sesión 2024",
                "url" : "/pdf/sesion3Cepci.pdf"
            },
            {
                "trimestre" : "Primera sesión 2025",
                "url" : "/pdf/1Cepci25.pdf"
            },
            {
                "trimestre" : "Segunda sesión 2025",
                "url" : "/pdf/2Cepci25.pdf"
            },
            {
                "trimestre" : "Tercera sesión 2025",
                "url" : "/pdf/3Cepci25.pdf"
            },
            {
                "trimestre" : "Cuarta sesión 2025",
                "url" : "/pdf/4Cepci25.pdf"
            },
            {
                "trimestre" : "Primera sesión 2026",
                "url" : "/pdf/1Cepci26.pdf"
            },
            {
                "trimestre" : "Segunda sesión 2026",
                "url" : "/pdf/2Cepci26.pdf"
            },
            {
                "trimestre" : "Convocatoria Protocolo Cero",
                "url" : "/pdf/convProtocoloCero.pdf"
            },
            {
                "trimestre" : "Pronunciamiento Protocolo Cero",
                "url" : "/pdf/pronProtocoloCero.pdf"
            },
            {
                "trimestre" : "Sesión de instalación Protocolo Cero",
                "url" : ""
            },
            {
                "trimestre" : "Directorio integrantes CEPCI",
                "url" : "/pdf/dirCepci.pdf"
            },
            {
                "trimestre" : "Directorio de personas consejeras",
                "url" : "/pdf/consejeros.pdf"
            },
            {
                "trimestre" : "Lineamiento de Denuncias",
                "url" : "/pdf/denunciaCEPCI.pdf"
            },
            
        ]
    },
    {
        "anio" : "Programa de Trabajo de Control Interno",
        "descripcion" : "PTCI",
        "trimestres" : [
            {
                "trimestre" : "Programa de Trabajo de Control Interno 2025",
                "url" : "/pdf/progCI2025.pdf"
            },
            {
                "trimestre" : "Programa de Trabajo de Control Interno 2026",
                "url" : "/pdf/ptci2026.pdf"
            },
            
            
        ]
    },
    {
        "anio" : "Programa de Trabajo de Administración de Riesgo",
        "descripcion" : "PTAR",
        "trimestres" : [
            {
                "trimestre" : "Programa de Trabajo de Administración de Riesgo 2026",
                "url" : "/pdf/ptar2026.pdf"
            }
        ]
    },
    {
        "anio" : "Información y Comunicación",
        "descripcion" : "Políticas, lineamientos, Evaluación",
        "trimestres" : [
            {
                "trimestre" : "Acerca de",
                "url" : "/pdf/acercadeinfo.pdf"
            },
            {
                "trimestre" : "Lineamientos para el uso y conservación de las Tecnologías de la Información y Comunicación de la SECTURH",
                "url" : "/pdf/ticsTur2025.pdf"
            },
            {
                "trimestre" : "Nuestro Portal Institucional",
                "url" : "https://s-turismo.hidalgo.gob.mx/"
            },
            {
                "trimestre" : "Evalua la información de nuestro portal",
                "url" : "https://docs.google.com/forms/d/e/1FAIpQLSewMha__USpUFrcDcAgil30R4iNgLcDskjchGP87RNpWxxjBQ/viewform"
            },
            {
                "trimestre" : "Hidalgo Travel                   ",
                "url" : "https://hidalgo.travel/wordpress/"
            },
            {
                "trimestre" : "Manual de Comunicación Interna y Externa de la Secretaría de Turismo del Poder Ejecutivo  del Estado de Hidalgo",
                "url" : "/pdf/manualComunica.pdf"
            },
            
        ]
    },
    
    {
        "anio" : "Denuncia",
        "descripcion" : "Formato de denuncia ante el CEPCI",
        "trimestres" : [
            {
                "trimestre" : "Formato",
                "url" : "/pdf/formatoDenuncia.pdf"
            }
        ]
    }
]